import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Box from '@mui/material/Box';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import { update } from '../../../common/api';


import '../modals.css';

const ClaimPartner = ( { orgId, close, user, c } ) => {
    const [ fullList, setFullList ] = useState( [] );
    const [ claimedBy, setClaimedBy ] = useState( '' );
    
    const handleChange = ( e ) => {
        setClaimedBy( e.target.value );
    }

    const applyClaim = async () => {
        const sharePartners = ( user && user.org && user.org.sharePartners === true ) ? true : false;
        const updated = await update( orgId, c.details.aid, user.email, 'contact', c.details.cid, { claimedBy: claimedBy }, sharePartners );
        if ( updated.length ) {
            toast.success( `The partner has been claimed!`, { theme: 'dark' } );
        }
        close();
    }

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length ) {
            const list = user.additionalAccounts.map( a => (
                {
                    ...a,
                    checked: ( user.viewing && user.viewing.find( f => f === a.aid ) !== undefined )
                }
            ) );
            setFullList( list );
        }
    }, [ user.additionalAccounts, user.viewing ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Claim Partner For...</Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Form.Group as={Row} className='tf-form-group align-items-center' controlId='partner-claim'>
                            <Col xs='auto' className='tf-form-select-field me-1'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={claimedBy} onChange={handleChange}>
                                    <option>Not Set</option>
                                    {
                                        fullList.map( ( a, idx ) => <option key={idx} value={a.aid}>{a.name}</option>)
                                    }
                                </Form.Select>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Button size='sm' variant='outline-primary' onClick={ () => applyClaim() } disabled={!claimedBy.length}>Claim</Button>
                    </Col>
                </Row>
            </Box>
            <ToastContainer autoClose={3000} />
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    user: state.user
} );
  
const mapDispatch = ( dispatch ) => ( {
    setViewing: dispatch.user.setViewing
} );
  
export default connect( mapProps, mapDispatch )( ClaimPartner );